/* unplugin-vue-components disabled */import script from "./ResourceBase.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResourceBase.vue?vue&type=script&setup=true&lang=ts"

import "./ResourceBase.vue?vue&type=style&index=0&id=5202831a&scoped=true&lang=scss"

import exportComponent from "/root/.jenkins/workspace/高保障-门户广西-前端页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5202831a"]])

export default __exports__